<ng-container *ngFor="let block of content">
  <p8-bdc-text-block *ngIf="block.type === 'text'" [block]="block"></p8-bdc-text-block>
  <p8-bdc-image-block *ngIf="block.type === 'image'" [block]="block"></p8-bdc-image-block>
</ng-container>

